<hr>
<div id="section-title">{{pageHeader}}</div>
<div class="row">
    <div class="column">
        <mm-condensed-label-group id="ach_transactionType" [title]="labels.transactionType" [data]="transactionType"></mm-condensed-label-group>
    </div>
    <div class="column" class="ach_direction">
        <mm-condensed-label-group id="ach_useStandingAuth" [title]="labels.transferDirection" [data]="transferDirection | titlecase"></mm-condensed-label-group>
        <div *ngIf="(transferDirection | titlecase) === 'Outgoing'; else incomingIcon"  id="outgoing-icon" data-testid="outgoing-icon">
            <img [src]="outgoing_svg" alt="outgoing-icon"  class="outgoing-icon">
        </div>
        <ng-template #incomingIcon>
            <img [src]="incoming_svg" alt="incoming-icon"  class="incoming-icon">
        </ng-template>
    </div>
    <div class="column">
        <mm-condensed-label-group id="ach_frequency" [title]="labels.frequency" [data]="frequency"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="!!frequencyOfOccurrence && isRecurringSetup">
        <mm-condensed-label-group id="ach_frequencyOccurrence" [title]="labels.frequencyDescription" [data]="frequencyOfOccurrence"></mm-condensed-label-group>
    </div>
    <ng-container *ngIf="!isRecurringSetup">
        <div class="column">
            <mm-condensed-label-group id="ach_processDate" [title]="labels.expectedWithdrawalDate" [data]="(withdrawalDate ? (withdrawalDate | formattedDate) : 'N/A')"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="!isTransactionViewPage">
            <mm-condensed-label-group id="ach_payee" [title]="labels.completionDate" [data]="(completionDate ? (completionDate | date : 'MM/dd/yyyy') : 'N/A')!"></mm-condensed-label-group>
        </div>
    </ng-container>
    <div class="column" *ngIf="transferDirection === 'incoming'">
        <mm-condensed-label-group id="ach_payee" [title]="labels.fundsAvailableToTrade" [data]=" (fundsAvailableToTrade ? (fundsAvailableToTrade | date : 'MM/dd/yyyy') : 'N/A')!"></mm-condensed-label-group>
    </div>
    <ng-container *ngIf="isRecurringSetup">
        <div class="column">
            <mm-condensed-label-group id="reviewPage_nextExpectedWithdrawalDate"
                data-testid="reviewPage_nextExpectedWithdrawalDate" [title]="labels.nextExpectedWithdrawalDate"
                [data]="(withdrawalDate ? (withdrawalDate | date : 'MM/dd/yyyy') : 'N/A')!">
            </mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="completionDate">
            <mm-condensed-label-group id="reviewPage_completionDateLabel" data-testid="reviewPage_completionDateLabel"
                [title]="labels.nextCompletionDate" [data]="(completionDate ? (completionDate | date : 'MM/dd/yyyy') : 'N/A')!">
            </mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="secondCompletionDate">
            <mm-condensed-label-group id="reviewPage_secondCompletionDateLabel"
                data-testid="reviewPage_secondCompletionDateLabel" [title]="labels.secondCompletionDate"
                [data]="secondCompletionDate">
            </mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="endDate">
            <mm-condensed-label-group id="reviewPage_endDate" data-testid="reviewPage_endDate" [title]="labels.endDate"
                [data]="endDate">
            </mm-condensed-label-group>
        </div>
    </ng-container>
    <div class="column">
        <mm-condensed-label-group id="ach_amount" [title]="labels.amount" [data]="grossOrNetAmount"></mm-condensed-label-group>
    </div>
    <div *ngIf="isIra && (transferDirection | titlecase) === 'Outgoing'" class="column" data-testid="ach_grossNet">
        <mm-condensed-label-group id="ach_grossNet" [title]="labels.grossNet" [data]="amountType | titlecase"></mm-condensed-label-group>
    </div>
    <div *ngIf="isIra && (transferDirection | titlecase) === 'Outgoing'" class="column" data-testid="ach_netCashAmount">
        <mm-condensed-label-group id="ach_netCashAmount" [title]="labels.netCashAmount" [data]="netAmount"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="enableAchPath && accountHolderRequestingTransaction" data-testid="ach_accountHolderRequestingTransaction">
        <mm-condensed-label-group id="ach_accountHolderRequestingTransaction" [title]="labels.accountHolderRequestingTransaction" [data]="accountHolderRequestingTransaction"></mm-condensed-label-group>
    </div>
</div>
<div id="reviewPage_withdrawalDateCopy">{{withdrawalDateCopy}}
     <span *ngIf="transferDirection === 'incoming'">{{fundsAvailableToTradeCopy}}</span>
</div>
